import { MdEdit, MdDelete } from 'react-icons/md';
import './TableRowIconActions.css';

/**
 * Shared Edit / Delete icon buttons for admin + receptionist tables.
 * Optional children render before the icons (e.g. Pay pending, Receipt).
 */
export default function TableRowIconActions({
  onEdit,
  onDelete,
  editLabel = 'Edit',
  deleteLabel = 'Delete',
  editDisabled = false,
  deleteDisabled = false,
  children = null,
}) {
  if (!onEdit && !onDelete && !children) return null;

  return (
    <div className="table-row-icon-actions">
      {children}
      {onEdit ? (
        <button
          type="button"
          className="table-row-icon-btn table-row-icon-btn-edit"
          onClick={onEdit}
          aria-label={editLabel}
          title={editLabel}
          disabled={editDisabled}
        >
          <MdEdit aria-hidden />
        </button>
      ) : null}
      {onDelete ? (
        <button
          type="button"
          className="table-row-icon-btn table-row-icon-btn-delete"
          onClick={onDelete}
          aria-label={deleteLabel}
          title={deleteLabel}
          disabled={deleteDisabled}
        >
          <MdDelete aria-hidden />
        </button>
      ) : null}
    </div>
  );
}
